import {memo} from 'react';
import {Image} from '../../../atoms/image';
import {PhoneCode} from '../../../../utils/phone-codes';
import {useFlagImage} from '../../../assets/use-flag-image';

export const FlagIcon = memo(
  ({country}: {country?: PhoneCode}) => {
    const flagSrc = useFlagImage(country?.code);

    if (!country) return null;

    if (flagSrc) {
      return (
        <Image
          width="24px"
          height="18px"
          src={flagSrc}
          alt={`${country.name} flag`}
        />
      );
    }

    return (
      <span
        role="img"
        aria-label={`${country.name} flag`}
        style={{fontSize: '20px', lineHeight: '20px'}}>
        {country.flag}
      </span>
    );
  },
  (prev, next) => prev.country?.code === next.country?.code,
);
